"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileContents = getFileContents;
exports.fileExists = fileExists;
exports.isResDepGraph = isResDepGraph;
exports.normalizeFilePath = normalizeFilePath;
exports.isSubpath = isSubpath;
const fs = require("fs");
const path = require("path");
function getFileContents(root, fileName) {
    const fullPath = path.resolve(root, fileName);
    if (!fs.existsSync(fullPath)) {
        throw new Error('Manifest ' + fileName + ' not found at location: ' + fileName);
    }
    const content = fs.readFileSync(fullPath, 'utf-8');
    return {
        content,
        fileName,
    };
}
function fileExists(root, fileName) {
    const fullPath = path.resolve(root, fileName);
    return fs.existsSync(fullPath);
}
function isResDepGraph(depRes) {
    return 'rootPkg' in depRes;
}
function normalizeFilePath(filePath) {
    return path.normalize(filePath).replace(/\\/g, '/');
}
function isSubpath(subpath, parentPath) {
    // Normalize both paths (ensure consistent separators)
    const normalizedSubpath = normalizeFilePath(subpath);
    const normalizedParentPath = normalizeFilePath(parentPath);
    // Ensure subpath starts with parent path
    return (normalizedSubpath == normalizedParentPath ||
        normalizedSubpath.startsWith(`${normalizedParentPath}/`));
}
//# sourceMappingURL=utils.js.map